import React, { useState } from 'react';
import StyledBox, {
  StyledMenu,
} from 'views/rebranded-module/common/components/Logical/LayoutV2/NavBar/LanguageAndRegion/LanguageAndRegion.styles';
import {
  MenuItem,
  IconButton,
  Tabs,
  Tab,
  Box,
  Typography,
  Grid,
} from '@mui/material';
import { RiGlobalLine } from 'react-icons/ri';
import axios, { API } from 'lib/config/axios';
import { useDispatch, useSelector } from 'react-redux';
import { setLoading } from 'redux/features/ui-slice';
import useErrorsHandler from 'views/rebranded-module/common/hooks/useErrorsHandler';
import useAppNavigator from 'views/rebranded-module/common/hooks/useAppNavigator';
import { useTranslation } from 'next-i18next';
import { mapNamedLocaleToLocale } from 'lib/data/localesMap';

const TABS_VALUES = {
  LANGUAGE: 0,
  CURRENCY: 1,
};

const LanguageAndRegion = () => {
  const { t } = useTranslation('common_layout_v2');
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedTab, setSeletedTab] = useState(TABS_VALUES.LANGUAGE);
  const [currencies, setCurrencies] = useState([]);
  const dispatch = useDispatch();
  const open = Boolean(anchorEl);
  const handleErrorResponse = useErrorsHandler();
  const appNavigator = useAppNavigator();
  const hreflangData = useSelector(
    (state) => state.globalData.hreflangData?.urls,
  );
  const {
    authenticity_token: authenticityToken,
    countries,
    current_currency: currentCurrency,
  } = useSelector((state) => state.globalData.appState);

  const getCurrencies = () => {
    if (currencies.length > 0) return;
    axios
      .get(API.currencies.index)
      .then((res) => {
        const { data } = res;
        if (data.currencies) {
          setCurrencies(data.currencies);
        }
      })
      .catch((error) => {
        handleErrorResponse(error);
      });
  };
  const handleOpen = (event) => {
    setAnchorEl(event.currentTarget);
    getCurrencies();
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const changeCurrency = async (newValue) => {
    try {
      await axios.post(API.currencies.change, {
        currency_id: newValue.id,
        authenticity_token: authenticityToken,
      });
      window.location.reload();
    } catch (error) {
      handleErrorResponse(error);
    } finally {
      dispatch(setLoading(false));
    }
  };
  const handleChangeCurrency = (e, newValue) => {
    if (newValue) {
      setLoading(true);
      changeCurrency(newValue);
    } else {
      handleClose();
    }
  };

  const handleChangeCountry = async (e, selectedCountry) => {
    if (!selectedCountry?.language_code) return;

    try {
      dispatch(setLoading(true));

      // Make the API call to change country
      await axios.post(API.countries.change, {
        country_id: selectedCountry.id,
        authenticity_token: authenticityToken,
      });

      // Handle the URL redirection
      const { url } = hreflangData.find((item) => (selectedCountry.language_code === 'en'
        ? item.hreflang === 'x-default'
        : item.hreflang === selectedCountry.language_code));

      const newUrl = new URL(url.split('?')[0], window.location.origin);
      newUrl.search = window.location.search;

      appNavigator.push(newUrl.toString());
    } catch (error) {
      handleErrorResponse(error);
    } finally {
      dispatch(setLoading(false));
      handleClose();
    }
  };
  const handleTabChange = (event, newIndex) => {
    setSeletedTab(newIndex);
  };

  return (
    <StyledBox>
      <IconButton onClick={handleOpen} className="LRMBtn">
        <RiGlobalLine />
      </IconButton>
      <StyledMenu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        disableScrollLock>
        {/* Tabs for switching between sections */}
        <Tabs value={selectedTab} onChange={handleTabChange} className="LRTabs">
          <Tab
            label={t('common_layout_v2:language')}
            value={TABS_VALUES.LANGUAGE}
            className="LRTab"
          />
          <Tab
            label={t('common_layout_v2:currency')}
            value={TABS_VALUES.CURRENCY}
            className="LRTab"
          />
        </Tabs>

        <Box className="LRTabsSections">
          {selectedTab === TABS_VALUES.LANGUAGE && (
            <Grid container spacing={2}>
              {countries?.map((country) => (
                <Grid item key={country.language_name} lg={6} md={6} sm={12}>
                  <MenuItem
                    className={`LRMenuItem ${
                      country.language_code
                      === mapNamedLocaleToLocale[appNavigator.locale]
                        ? 'LRMenuItemSelected'
                        : ''
                    }`}
                    onClick={(e) => handleChangeCountry(e, country)}>
                    {country.language_name}
                  </MenuItem>
                </Grid>
              ))}
            </Grid>
          )}
          {selectedTab === TABS_VALUES.CURRENCY && (
            <Grid container spacing={2}>
              {currencies.map((currency) => (
                <Grid item key={currency.name} lg={6} md={6} sm={12}>
                  <MenuItem
                    onClick={(e) => handleChangeCurrency(e, currency)}
                    className={`LRMenuItem ${
                      currency.symbol.includes(currentCurrency?.symbol)
                        ? 'LRMenuItemSelected'
                        : ''
                    }`}>
                    {currency.symbol || ''}
                    <Typography component="span" className="LRCurrencyName">
                      {currency.name || ''}
                    </Typography>
                  </MenuItem>
                </Grid>
              ))}
            </Grid>
          )}
        </Box>
      </StyledMenu>
    </StyledBox>
  );
};

export { LanguageAndRegion };
